import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=423492c3&scoped=true&"
import script from "./CalendarIcon.vue?vue&type=script&lang=js&"
export * from "./CalendarIcon.vue?vue&type=script&lang=js&"
import style0 from "./CalendarIcon.vue?vue&type=style&index=0&id=423492c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423492c3",
  null
  
)

export default component.exports